import { ThunkApiType } from 'types/storeTypes';
import authFetch, { checkForUnauthorizedResponse } from '../../utils/axios';

import { getLocaleLanguage } from 'utils/utils';

export const getFooterLinksThunk = async (
	_: string,
	thunkAPI: ThunkApiType,
) => {
	const lang = getLocaleLanguage();

	const getFooterLinksUrl = `/cms/provider-portal-footer/?populate=*&locale=${lang}`;

	try {
		const response = await authFetch.get(getFooterLinksUrl);
		return response.data.data.attributes.links;
	} catch (error: ThunkApiType) {
		return checkForUnauthorizedResponse(error, thunkAPI);
	}
};
